import { NextButton, PreviousButton } from '@library/components/buttons';
import { classNames } from '@library/utils';

export interface CustomDateHeaderProps {
  monthDate: Date;
  customHeaderCount: number;
  decreaseMonth: () => void;
  increaseMonth: () => void;
  oneMonthOnly: boolean;
}

export const CustomDateHeader = ({
  monthDate,
  customHeaderCount,
  decreaseMonth,
  increaseMonth,
  oneMonthOnly
}: CustomDateHeaderProps) => {
  return (
    <div className="bg-soFresh-110">
      <PreviousButton
        label="Previous Month"
        className={classNames(
          customHeaderCount === 1 && !oneMonthOnly ? 'hidden' : '',
          'absolute top-[2px] z-10 flex h-5 w-12 cursor-pointer items-center justify-center overflow-hidden border-none bg-none p-0 text-center'
        )}
        handleOnClick={decreaseMonth}
        testId="previous-month-button"
      />
      <span className="font-heebo text-soClean-100 mt-0 text-base">
        {monthDate.toLocaleString('en-US', {
          month: 'long',
          year: 'numeric'
        })}
      </span>
      <NextButton
        label="Next Month"
        className={classNames(
          customHeaderCount === 0 && !oneMonthOnly ? 'hidden' : '',
          'absolute right-[4px] top-[2px] z-10 flex h-5 w-12 cursor-pointer items-center justify-center overflow-hidden border-none bg-none p-0 text-center'
        )}
        handleOnClick={increaseMonth}
        testId="next-month-button"
      />
    </div>
  );
};
